import { render } from "./SidenavItem.vue?vue&type=template&id=d126af86"
import script from "./SidenavItem.vue?vue&type=script&lang=js"
export * from "./SidenavItem.vue?vue&type=script&lang=js"
script.render = render

export default script